/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_NoteInputs */

const en_gc_resources_guide_start_note = /** @type {(inputs: Gc_Resources_Guide_Start_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The browser workspace processes files locally. Closing or refreshing the tab can discard unsaved changes.`)
};

const zh_gc_resources_guide_start_note = /** @type {(inputs: Gc_Resources_Guide_Start_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器工作空间在本地处理文件。关闭或刷新标签页可能丢失未保存的修改。`)
};

/**
* | output |
* | --- |
* | "The browser workspace processes files locally. Closing or refreshing the tab can discard unsaved changes." |
*
* @param {Gc_Resources_Guide_Start_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_note = /** @type {((inputs?: Gc_Resources_Guide_Start_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_note(inputs)
	return zh_gc_resources_guide_start_note(inputs)
});
export { gc_resources_guide_start_note as "gc.resources.guide.start.note" }